export default "__VITE_ASSET__DrGb7ClW__"